export default __webpack_public_path__ + "static/media/gallery_02.b6b0616a.jpg";